// 認証
export const LOGIN_FOR_WEB = "login_for_web";
export const REG_FOR_WEB = "reg_for_web";
export const ACT = "act";

// ユーザー情報
export const GET_USER_INF = "get_user_inf";
export const GET_USER_INF_FOR_WEB = "get_user_inf_for_web";
export const UPD_USER_INF = "upd_user_inf";
export const SET_CALL_WAITING = "set_call_waiting";
export const CHANGE_EMAIL_VERSION_2 = "change_email_version_2";

// 公開画像
export const LST_PBIMG = "lst_pbimg";

// ポイント
export const GET_POINT = "get_point";
export const GET_UTAGE_WEB_POINT_INFO = "get_utage_web_point_info";
export const LST_POINT_PCK = "lst_point_pck";
export const SAVE_WEB_PAYMENT_POINT_LOG = "save_web_payment_point_log";
export const UPDATE_WEB_PAYMENT_POINT_LOG_STATUS =
  "update_web_payment_point_log_status";
export const ADD_POINT_FOR_WEB_PAYMENT = "add_point_for_web_payment";
export const PAIDY_CAPTURE = "paidy_capture";
export const STRIPE_CREATE_CHECKOUT_SESSION = "stripe_create_checkout_session";
export const STRIPE_CHECKOUT_CAPTURE = "stripe_checkout_capture";

// デイリーボーナス
export const UTAGE_WEB_DAILY_BONUS = "utage_web_daily_bonus";

// ディスカバー・検索
export const UTAGE_WEB_GET_MEET_PEOPLE_EXCLUDE_VIDEO_CALL_CHANNELER =
  "utage_web_get_meet_people_exclude_video_call_channeler";
export const GET_RECENT_VIDEO_CALL_FEMALE_USERS =
  "get_recent_video_call_female_users";
export const GET_HIGH_REVIEW_SCORE_USERS = "get_high_review_score_users";
// Koru（application_id=106）向けに表示する女性ユーザー一覧を返す UMS API（keyset ページング対応）
export const KORU_GET_USERS = "koru_get_users";

// お気に入り（いいね・ハート）
export const ADD_FAV = "add_fav";
export const LST_FAV = "lst_fav"; // 自分から送ったいいね一覧
export const LST_FVT = "lst_fvt"; // 相手からもらったいいね一覧

// ブックマーク（☆ = UI 上の「お気に入り」）
export const ADD_BOOKMARK = "add_bookmark";
export const DELETE_BOOKMARK = "delete_bookmark";
export const LIST_BOOKMARK = "list_bookmark";

// フットプリント
export const GET_FOOTPRINT_HISTORY_FOR_WEB = "get_footprint_history_for_web";

// ギャラリー
export const GET_GALLERY_ITEMS = "get_gallery_items";
export const GET_UNOPENED_ITEM = "get_unopened_item";
export const CHANGE_GALLERY_ITEM_FAVORITE_STATUS =
  "change_gallery_item_favorite_status";

// ライブ
export const SECOND_APPS_GET_LIVE_CHANNELS = "second_apps_get_live_channels";
// 未ログインの直リンク視聴（/watch）。指定した配信者の配信へ映像だけを見に入る接続情報を返す（token 不要）
export const SECOND_APPS_GET_LIVE_WATCH_WITHOUT_TOKEN =
  "second_apps_get_live_watch_without_token";
export const PAY_SECOND_LIVE_POINT = "pay_second_live_point";

// ビデオ通話
export const GET_VIDEO_CHAT_CHANNEL = "get_video_chat_channel";
export const GET_RTM_LOGIN_AUTH = "get_rtm_login_auth";
export const GET_WEB_INCOMING_CALL = "get_web_incoming_call";
export const PAY_SECOND_VIDEO_CALL_POINT = "pay_second_video_call_point";
export const ENDED_CALL_NOTIFICATION = "ended_call_notification";

// 音声通話
export const SEND_VOICE_CALL_VOIP_FOR_SECOND =
  "send_voice_call_voip_for_second";
export const PAY_SECOND_VOICE_CALL_POINT = "pay_second_voice_call_point";
export const GET_UNCOMPLETED_LOVENSE_LOG_BY_ROOM =
  "get_uncompleted_lovense_log_by_room";
export const SEND_CALL_REQUEST_FROM_WEB = "send_call_request_from_web";
export const SEND_LOVENSE_CONTROL_COMMAND = "send_lovense_control_command";
export const UTAGE_WEB_ABSENCE_CALL_MESSAGE_NOTIFICATION =
  "utage_web_absence_call_message_notification";

// メッセージ
export const LIST_CONVERSATION = "list_conversation";
export const TOTAL_UNREAD = "total_unread";
export const GET_CHAT_HISTORY = "get_chat_history";
export const SEND_MESSAGE_FROM_WEB = "send_message_from_web";
export const MARK_READS = "mark_reads";
export const DEL_CONVERSATIONS = "del_conversations";
export const GET_OPENED_IMAGE = "get_opened_image";
export const GET_OPENED_VIDEO = "get_opened_video";
export const SEND_IMAGE_FROM_WEB = "send_image_from_web";
export const SEND_VIDEO_FROM_WEB = "send_video_from_web";
export const VIEW_IMG = "view_img";
export const VIEW_VIDEO = "view_video";
export const ADD_OPENED_CONTENT = "add_opened_content";

// モデレーション
export const LST_BLK = "lst_blk";
export const ADD_BLK = "add_blk";
export const RMV_BLK = "rmv_blk";
export const RPT = "rpt";

// ボード
export const GET_UTAGE_WEB_BOARD_MESSAGE = "get_utage_web_board_message";
export const POST_SESSION_BOARD_MESSAGE = "post_session_board_message";

// レビュー
export const GET_USER_REVIEW_LIST = "get_user_review_list";
export const GET_REVIEW_POSTING_ENABLED = "get_review_posting_enabled";
export const POST_USER_REVIEW = "post_user_review";

// フリマ
export const GET_FLEA_MARKET_ITEM_LIST = "get_flea_market_item_list";
export const GET_FLEA_MARKET_ITEM_DETAIL = "get_flea_market_item_detail";
export const GET_FLEA_MARKET_FAVORITE_LIST = "get_flea_market_favorite_list";
export const GET_FLEA_MARKET_TRANSACTION_LIST =
  "get_flea_market_transaction_list";
export const GET_FLEA_MARKET_TRANSACTION_DETAIL =
  "get_flea_market_transaction_detail";
export const GET_FLEA_MARKET_SHIPMENTS_DETAIL =
  "get_flea_market_shipments_detail";
export const GET_ADDRESS_FLEA_MARKET = "get_address_flea_market";
export const ADD_FLEA_MARKET_FAVORITE = "add_flea_market_favorite";
export const REMOVE_FLEA_MARKET_FAVORITE = "remove_flea_market_favorite";
export const CREATE_FLEA_MARKET_TRANSACTION = "create_flea_market_transaction";
export const UPDATE_FLEA_MARKET_TRANSACTION = "update_flea_market_transaction";
export const UPDATE_FLEA_MARKET_SHIPMENT_STATUS =
  "update_flea_market_shipment_status";
export const REGISTER_ADDRESS_FLEA_MARKET = "register_address_flea_market";

// 設定
export const DE_ACT = "de_act";

// クレジット購入
export const GET_CREDIT_PURCHASE_COURSE_INFO =
  "get_credit_purchase_course_info";

// 通知
export const UTAGE_WEB_POLLING = "utage_web_polling";
export const GET_NOTI_SETTING_FOR_WEB = "get_noti_setting_for_web";
export const GET_NOTI_SET = "get_noti_set";
export const NOTI_SET = "noti_set";
export const UPD_NOTI_SETTING_FOR_WEB = "upd_noti_setting_for_web";
